export const HEADER_HEIGHT_WITH_TRIAL = '110px'
export const HEADER_HEIGHT_WITHOUT_TRIAL = '74px'

export const TABLE_HEIGHT_WITH_TRIAL = '276px'
export const TABLE_HEIGHT_WITHOUT_TRIAL = '240px'
export const TABLE_HEIGHT_WITH_TRIAL_AND_PAGES = '324px'
export const TABLE_HEIGHT_WITHOUT_TRIAL_AND_PAGES = '288px'
export const TABLE_HEIGHT_WITH_TRIAL_AND_SCIM = '344px'
export const TABLE_HEIGHT_WITHOUT_TRIAL_AND_SCIM = '308px'
